import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ClipboardCheck, X, MessageCircle } from 'lucide-react';

const SUPPORT_WHATSAPP = '16478745620';

const FloatingQuizButton = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Show floating button after 3 seconds of page load
    const timer = setTimeout(() => {
      if (!isDismissed) {
        setIsVisible(true);
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [isDismissed]);

  const handleDismiss = (e) => {
    e.stopPropagation();
    setIsVisible(false);
    setIsDismissed(true);
  };

  const handleClick = () => {
    const message = language === 'ar'
      ? 'مرحباً! أريد معرفة نتائج التقييم المجاني'
      : 'Hello! I want to know my free assessment results';
    const whatsappUrl = `https://wa.me/${SUPPORT_WHATSAPP}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  if (!isVisible || isDismissed) return null;

  const content = {
    en: "Free Assessment",
    ar: "تقييم مجاني"
  };

  return (
    <>
      <div className="fixed bottom-8 right-8 z-40">
        <div className="group relative">
          <button
            onClick={handleClick}
            className="bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white w-14 h-14 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center"
            title={content[language]}
          >
            <ClipboardCheck className="w-6 h-6" />
          </button>
          
          {/* Close button */}
          <span
            role="button"
            tabIndex={0}
            onClick={handleDismiss}
            onKeyDown={(e) => e.key === 'Enter' && handleDismiss(e)}
            className="absolute -top-1 -right-1 w-5 h-5 bg-gray-800 hover:bg-gray-900 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
          >
            <X className="w-3 h-3" />
          </span>
        </div>
      </div>
    </>
  );
};

export default FloatingQuizButton;
